var _gaq = _gaq || [];
window.dataLayer = window.dataLayer || []

var rr = rr || {};
rr.log_click = function (url) {
    var img = new Image();
    img.src = url;
};

function StullerTrackEvent(category, action, label, value, nonInteraction) {
    // Begin Universal Analytics
    var fieldsObject = {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
    };

    if (nonInteraction) {
        fieldsObject.nonInteraction = nonInteraction;
    }

    __gaTracker('send', 'event', fieldsObject);
  // End Universal Analytics

  // Begin Google Tag Manager / Google Analytics 4

  // remove surrounding ticks and quotes, they were mistakenly added to the event tracking we had for universal/classic analytics
  // hunter didn't want to change the behavior for universal/classic so that he could preserve yoy reporting but did want it fixed for ga4
  // once universal tracking is ended, we should go about fixing these at the source
  var removeSurroundingQuotesRegex = new RegExp(`^('|")(.*)\\1$`, 'gs')

  var strippedValues = [category, action, label].map(function (value) {
    if (value == null) {
      return value
    }

    return value.replace(removeSurroundingQuotesRegex, '$2')
  })

  window.dataLayer.push({ details: null })
  window.dataLayer.push({
    event: 'universal',
    details: {
      category: strippedValues[0],
      action: strippedValues[1],
      label: strippedValues[2],
      value
    }
  })
  // End Google Tag Manager / Google Analytics 4
};

addStullerEventListener('track-event', function (event) {
  window.dataLayer.push({ details: null })
  window.dataLayer.push({
    event: event.detail.event,
    details: event.detail.details
  })
})

addStullerEventListener('track-universal-event', function (event) {
  var details = event.detail
  StullerTrackEvent(details.category, details.action, details.label, details.value)
})
